import { render, staticRenderFns } from "./OrdenImportacion.vue?vue&type=template&id=65687a1d&scoped=true&"
import script from "./OrdenImportacion.vue?vue&type=script&lang=js&"
export * from "./OrdenImportacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65687a1d",
  null
  
)

export default component.exports